import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PaymentChannelEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  ext_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  date_txn?: Optional<string> = Optional.empty();
  obj_action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  id_user?: Optional<string> = Optional.empty();
  id_device?: Optional<string> = Optional.empty();

  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();
}

export class PaymentChannelEventCriteriaModelQuery {
  query = '';

  constructor(pcEventCriteriaModel: PaymentChannelEventQueryCriteriaClass) {
    console.log('pcEventCriteriaModel', pcEventCriteriaModel);

    if (!pcEventCriteriaModel) {
      return;
    }

    this.query += pcEventCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += pcEventCriteriaModel.ext_guid.filter(x => x !== '').map(x => '&ext_guid=' + x).orElse('');
    this.query += pcEventCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += pcEventCriteriaModel.date_txn.filter(x => x !== '').map(x => '&date_txn=' + x).orElse('');
    this.query += pcEventCriteriaModel.obj_action.filter(x => x !== '').map(x => '&obj_action=' + x).orElse('');

    this.query += pcEventCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += pcEventCriteriaModel.id_user.filter(x => x !== '').map(x => '&id_user=' + x).orElse('');
    this.query += pcEventCriteriaModel.id_device.filter(x => x !== '').map(x => '&id_device=' + x).orElse('');
    this.query += pcEventCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += pcEventCriteriaModel.updated_date.filter(x => x !== null).map(x => '&updated_date=' + x).orElse('');


    this.query += '&status=' + pcEventCriteriaModel.status;
    this.query += '&orderBy=' + pcEventCriteriaModel.orderBy;
    this.query += '&order=' + pcEventCriteriaModel.order;
    this.query += '&offset=' + pcEventCriteriaModel.offset + '&limit=' + pcEventCriteriaModel.limit;
  }

}
